import request from '../network';

export interface PetBreedItem {
  id?: number | null;
  breedCode?: string;
  breedName?: string;
  petType?: string | number | null;
  bodySize?: string | null;
  imgUrl?: string | null;
  isShow?: number | null;
}

export const getPetBreedListApi = (params?: { petType?: string | number }) => {
  return request<{ code: number; msg?: string; data?: PetBreedItem[] }>({
    url: '/member/royalcanin/admin/petBreed/getList',
    method: 'GET',
    params,
  });
};
